import { axiosInstance } from "../../axios/axiosInstance";
import {
  ADMIN_API_URL,
  API_BASE_URL,
  getDefaultHeaders,
} from "../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getGeneralSettings = () =>
  axiosInstance.get(`${ADMIN_API_URL}/admin/get-general-settings`, {
    headers: authHeaders(),
  });

export const updateGeneralSettingsRequest = (settings) =>
  axiosInstance.post(`${ADMIN_API_URL}/update-general-settings`, settings, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const getPasswordPolicy = () =>
  axiosInstance.get(`${ADMIN_API_URL}/password-policy`, {
    headers: authHeaders(),
  });

export const updatePasswordPolicyRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/password-policy`, payload, {
    headers: authHeaders(),
  });

export const getSmtpEncryptions = () =>
  axiosInstance.get(`${API_BASE_URL}/get/smtp-encryptions`, {
    headers: authHeaders(),
  });

export const getEmailDeliveryTypes = () =>
  axiosInstance.get(`${API_BASE_URL}/get/email-delivery-types`, {
    headers: authHeaders(),
  });

export const getPasswordReminders = () =>
  axiosInstance.get(`${API_BASE_URL}/get/password-reminders`, {
    headers: authHeaders(),
  });

export const getFormatNameSeeder = () =>
  axiosInstance.get(`${API_BASE_URL}/get/download-file-name-format-seeder`, {
    headers: authHeaders(),
  });
